export const LOGIN = "LOGIN";
export const SIGNUP = "SIGNUP";
export const LOGOUT = "LOGOUT";
export const REGISTER_LOADER = "REGISTER_LOADER";
export const LOGIN_LOADER = "LOGIN_LOADER";
export const USER_FRIENDLY_ERR_MSG = "USER_FRIENDLY_ERR_MSG";
export const SET_UPGRADE_ACTIVITIES = "SET_UPGRADE_ACTIVITIES";
